import { render, staticRenderFns } from "./Comparify.vue?vue&type=template&id=468f04bb&scoped=true&"
import script from "./Comparify.vue?vue&type=script&lang=js&"
export * from "./Comparify.vue?vue&type=script&lang=js&"
import style0 from "./Comparify.vue?vue&type=style&index=0&id=468f04bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468f04bb",
  null
  
)

export default component.exports